export enum TalentSeekerOnboardedStatus {
  ALLOWED = "allowed",
  BLOCKED = "blocked",
  UNKNOWN = "unknown"
}

export interface IFlags {
  experiencesVerificationsSurvey: boolean;
  firstGetSignalBenefitsViewed: boolean;
  firstSignalOnBoarded: boolean;
  firstSignalSent: boolean;
  matchAndRankDisclaimerViewed: boolean;
  membersBenefitsViewed: boolean;
  notificationsPhrasesSarcastic: boolean;
  opportunitiesBenefitsViewed: boolean;
  referredMatchUnderstood: boolean;
  torreMatchAcknowledged: boolean;
  automessagesMeetingsButtonViewed: boolean;
  signedInToOpportunities: boolean;
  contactsImported: boolean;
  opportunityOperator: boolean;
  opportunityCrawler: boolean;
  veiled: boolean; // True when the user is marked as a scammer.
  earlyAccess: boolean;
  appDownloaded?: boolean;
  talentSeekerOnboarded: TalentSeekerOnboardedStatus | null;
  onboardingBenefitsViewed?: boolean;
}

export class Flags {
  public experiencesVerificationsSurvey: boolean;
  public firstGetSignalBenefitsViewed: boolean;
  public firstSignalOnBoarded: boolean;
  public firstSignalSent: boolean;
  public matchAndRankDisclaimerViewed: boolean;
  public membersBenefitsViewed: boolean;
  public notificationsPhrasesSarcastic: boolean;
  public opportunitiesBenefitsViewed: boolean;
  public referredMatchUnderstood: boolean;
  public torreMatchAcknowledged: boolean;
  public automessagesMeetingsButtonViewed: boolean;
  public signedInToOpportunities: boolean;
  public contactsImported: boolean;
  public opportunityOperator: boolean;
  public opportunityCrawler: boolean;
  public veiled: boolean;
  public earlyAccess: boolean;
  public appDownloaded?: boolean;
  public talentSeekerOnboarded: TalentSeekerOnboardedStatus | null;

  constructor(data: IFlags) {
    this.experiencesVerificationsSurvey = data.experiencesVerificationsSurvey;
    this.firstGetSignalBenefitsViewed = data.firstGetSignalBenefitsViewed;
    this.firstSignalOnBoarded = data.firstSignalOnBoarded;
    this.firstSignalSent = data.firstSignalSent;
    this.matchAndRankDisclaimerViewed = data.matchAndRankDisclaimerViewed;
    this.membersBenefitsViewed = data.membersBenefitsViewed;
    this.notificationsPhrasesSarcastic = data.notificationsPhrasesSarcastic;
    this.opportunitiesBenefitsViewed = data.opportunitiesBenefitsViewed;
    this.referredMatchUnderstood = data.referredMatchUnderstood;
    this.torreMatchAcknowledged = data.torreMatchAcknowledged;
    this.automessagesMeetingsButtonViewed = data.automessagesMeetingsButtonViewed;
    this.signedInToOpportunities = data.signedInToOpportunities;
    this.contactsImported = data.contactsImported;
    this.opportunityOperator = data.opportunityOperator;
    this.opportunityCrawler = data.opportunityCrawler;
    this.veiled = data.veiled;
    this.earlyAccess = data.earlyAccess;
    this.appDownloaded = data.appDownloaded;
    this.talentSeekerOnboarded = data.talentSeekerOnboarded;
  }
}
